/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let productMetaDescription = document.getElementById('product-meta-description')
if(productMetaDescription) {
  let openSizeChart = productMetaDescription.querySelector('[href="#OpenSizeChart"]')
  let openSizeChartBtn = document.getElementById('open-size-chart-btn')
  if(openSizeChart && openSizeChartBtn) {
    openSizeChart.addEventListener('click', (e) => {
      e.preventDefault()
      openSizeChartBtn.click()
    })
  }
}

function getElementOffsetTop(element) {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  return rect.top + scrollTop;
}

let productAddToCartBtn = document.getElementById('product-add-to-cart-btn')
let productBar = document.getElementById('product-bar')
let footer = document.getElementById('shopify-section-footer')
let isBtnIntersecting = false
let isFooterIntersecting = false
const productBtnTop = getElementOffsetTop(productAddToCartBtn);

if(productAddToCartBtn) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(window.scrollY > productBtnTop) {
        switch (entry.target.id) {
          case 'product-add-to-cart-btn':
            isBtnIntersecting = entry.isIntersecting
            break;
          case 'shopify-section-footer':
            isFooterIntersecting = entry.isIntersecting
            break;
        }
  
        if(!isBtnIntersecting && !isFooterIntersecting) {
          productBar.classList.add('ProductBar--visible')
        } else {
          productBar.classList.remove('ProductBar--visible')
        }
      } else {
        if (productBar.classList.contains('ProductBar--visible')) productBar.classList.remove('ProductBar--visible')
      }
    })
  }, { threshold: 0.7, rootMargin: '0px 0px 0px 0px'})

  observer.observe(productAddToCartBtn)
  observer.observe(footer)
}

document.addEventListener('product:added', function(event) {
  document.querySelector('.Cart__Count').textContent = parseInt(document.querySelector('.Cart__Count').textContent) + event.detail.quantity;
});

var notifier = document.querySelector('stock-notifier');
if (notifier) {
  var form = notifier.querySelector('form');
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;

    if (variant.available) {
      notifier.classList.add('hidden');
    } else {
      form.querySelector('[name="variant"]').value = variant.id;
      notifier.classList.remove('hidden');
    }
  });
}

const klaviyoForm = function(event) {
  event.preventDefault();

  const error = function(err) {
    if (err) console.error(err);
    alert(window.languages['error']);
  }

  const form = event.target.closest('form');
  const email = form.querySelector('[type="email"]').value;
  const data = {
    g: form.querySelector('[name="g"]').value,
    email: form.querySelector('[type="email"]').value,
  }

  if (tags = form.querySelector('[name="tags"]')) {
    data.$fields = '$source';
    data.$source = tags.value;
  }

  const urlData = new URLSearchParams(data);

  fetch(form.dataset.ajaxSubmit, {
    method: 'POST',
    body: urlData,
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      var thanks = form.parentNode.querySelector('.thanks');
      if (thanks) {
        form.style.display    = 'none';
        thanks.style.display  = 'block';
      } else {
        alert(window.languages.newsletterThankYou);
      }
    } else {
      //error(data.errors.join(' '));
      form.submit;
    }
  })
  .catch(e => {
    error(e);
  });
};

let observerOptions = {
  rootMargin: '0px',
  threshold: 0.5
}

let newObserver = new IntersectionObserver(observerCallback, observerOptions);

function observerCallback(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.addEventListener('submit', klaviyoForm.bind(this));
    }
  });
};

document.querySelectorAll('form.klaviyo').forEach((form) => {
  if (form) newObserver.observe(form);
});